import { TAREFA_TIPO_COLOR_MAP } from "@/constants/statusColors";
import { TarefaTipo, TarefaTipoMap } from "@workflow/types";
import { cn } from "@/lib/utils";
import { StatusBadge } from "../ui/badge-status";

interface TarefaTipoBadgeProps {
  tipo: TarefaTipo;
  className?: string;
}

export function TarefaTipoBadge({ tipo, className }: Readonly<TarefaTipoBadgeProps>) {
  const text = TarefaTipoMap[tipo] || tipo;
  const colorClass = TAREFA_TIPO_COLOR_MAP[tipo] || TAREFA_TIPO_COLOR_MAP.SOLICITAR_AP;

  return (
    <StatusBadge title={text} color={colorClass} className={cn(className)}>
      {text}
    </StatusBadge>
  );
}
